import React from 'react';
import {Card, Grid} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

import {SingleSelect} from 'spectra-logic-ui/components';
import {ItemDetails} from '@/storage/form/pages/onsite/quota_card';
import {numberToHumanSize} from 'spectra-logic-ui/helpers/number';

const useStyles = makeStyles({
  root: {
    padding: 15,
    marginTop: 10,
  },
  grid: {
    '& > *': {
      marginBottom: 10,
    },
  },
});

const RecordSizeCard = (props: {itemDetails: ItemDetails}) => {
  const classes = useStyles();

  const recordSizeToolTip = 'Set the recordSize ' +
  'for the underlying ZFS volume.';
  const recordSizeOptions = [{
    key: '1048576',
    text: 'Default - Performance',
  }, {
    key: '524288',
    text: 'Small Objects',
  }];
  if (props.itemDetails && props.itemDetails.recordSize) {
    if (!['', '1048576', '524288'].includes(String(props.itemDetails.recordSize))) {
      recordSizeOptions.unshift({
        key: String(props.itemDetails.recordSize),
        text: 'Nonstandard (' + numberToHumanSize(props.itemDetails.recordSize) + ')',
      });
    }
  }
  return (
    <Card className={classes.root}>
      <Grid container spacing={2} className={classes.grid}>
        <Grid item xs={6}>
          <SingleSelect
            parse={(value) => {
              const number = Number(value);
              if (!value && value !== '0') {
                return null;
              } else if (isNaN(number)) {
                return value;
              } else {
                return number;
              }
            }}
            options={recordSizeOptions}
            name='recordSize'
            label='Record Size'
            tooltip={recordSizeToolTip}
          />
        </Grid>
      </Grid>
    </Card>
  );
};

export default RecordSizeCard;
